import { render, staticRenderFns } from "./RegisteredMember.vue?vue&type=template&id=b0ff73e6&scoped=true&"
import script from "./RegisteredMember.vue?vue&type=script&lang=js&"
export * from "./RegisteredMember.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredMember.vue?vue&type=style&index=0&id=b0ff73e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ff73e6",
  null
  
)

export default component.exports